import React, {useState} from 'react';

const Header = () => {
    return (
        <header>
            <h3>Immobilia</h3>
            <button>Déconnexion</button>
        </header>
    )
}

export default Header;